/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchProductsRequestInnerAllOfSchedulesInnerDaysInner
 */
export interface PatchProductsRequestInnerAllOfSchedulesInnerDaysInner {
}

/**
 * Check if a given object implements the PatchProductsRequestInnerAllOfSchedulesInnerDaysInner interface.
 */
export function instanceOfPatchProductsRequestInnerAllOfSchedulesInnerDaysInner(value: object): value is PatchProductsRequestInnerAllOfSchedulesInnerDaysInner {
    return true;
}

export function PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSON(json: any): PatchProductsRequestInnerAllOfSchedulesInnerDaysInner {
    return PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSONTyped(json, false);
}

export function PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchProductsRequestInnerAllOfSchedulesInnerDaysInner {
    return json;
}

export function PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSON(json: any): PatchProductsRequestInnerAllOfSchedulesInnerDaysInner {
    return PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSONTyped(json, false);
}

export function PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSONTyped(value?: PatchProductsRequestInnerAllOfSchedulesInnerDaysInner | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

